import React from "react";
import Loadable from "react-loadable";

import DotSpinner from "@exovera/dot-spinner";

const ThailandMapLoader = Loadable.Map({
	loader: {
		MapComponent: () => import(/* webpackChunkName: "map" */ "genericComponents/Map"),
		asiaMapObject: () => import(/* webpackChunkName: "map" */ "static/maps/jsMaps/asia.js"),
		thailand: () => import(/* webpackChunkName: "map" */ "static/maps/jsMaps/thailand.js"),
		mapIndex: () => import(/* webpackChunkName: "map" */ "lib/maps/mapIndexThailand.js"),
		baseIcon: () => import(/* webpackChunkName: "map" */ "lib/maps/tinyAsia.js"),
	},
	loading: DotSpinner,
	render(loaded, props) {
		const { actions } = props;
		const Map = loaded.MapComponent.default;
		const mapIndex = loaded.mapIndex.default;
		const asiaMapObject = loaded.asiaMapObject.default;
		const thailand = loaded.thailand.default;
		const baseIcon = loaded.baseIcon.default;

		return (
			<Map
				{...props}
				reactSimpleMaps={null}
				baseMapObject={asiaMapObject}
				states={null}
				mapIndex={mapIndex}
				baseIcon={baseIcon} // Pass a tiny map svg/js object here, or false to disable
				states={thailand}
				loaderID="ThailandMapLoader"
				clickableStates={["thailand"]}
				// trigger remount between detailed and base maps (prevents awkward transition)
				key={props.mapHighlight ? "mapHighlight" : "baseMap"}
				mapHighlightDisabled={false}
				mapId="base"
				maxHeight={600} // 400 for US map
				moeMode={false}
				subtractFromHeight={100} // 360 for US map
				wideMap // true for US map
				// actions
				clearMap={actions.clearMap}
				clearMapPlay={actions.clearMapPlay}
				clickMap={actions.clickMap}
				hoverMap={actions.hoverMap}
				incrementMapPosition={actions.incrementMapPosition}
				setMapPosition={actions.setMapPosition}
				toggleMapPlay={actions.toggleMapPlay}
				unhoverMap={actions.unhoverMap}
			/>
		);
	},
});

export default ThailandMapLoader;
